import { gql } from '@apollo/client';

export default gql`
  query spaceNameAvailable($name: String!) {
    spaceNameAvailable(name: $name)
  }
`;
